export type ApiErrorBody = {
  ok?: false
  error?: string
  fieldErrors?: Record<string, string[] | undefined>
  [key: string]: unknown
}

export class ApiError extends Error {
  readonly status: number
  readonly body: ApiErrorBody | null

  constructor(status: number, body: ApiErrorBody | null, message?: string) {
    super(message ?? body?.error ?? 'request_failed')
    this.name = 'ApiError'
    this.status = status
    this.body = body
  }

  get fieldErrors(): Record<string, string[] | undefined> | undefined {
    return this.body?.fieldErrors
  }

  fieldError(key: string): string | undefined {
    return this.fieldErrors?.[key]?.[0]
  }

  static is(e: unknown): e is ApiError {
    return e instanceof ApiError
  }
}
